import 'whatwg-fetch';
import qs from 'query-string';
import React from 'react';
import { connect } from 'react-redux';
import Box from "signoxe/components/layout/Box";
import Button from "signoxe/components/widgets/Button";
import { getAsset, getWeatherTemplates } from 'signoxe/selectors';
import { Page } from 'signoxe/components';
import { API_ROOT } from 'signoxe/constants/config';
import {
    setAQICities, setWeatherStations, setPageTitle,
    addZipAsset, updateAQIVedaAsset,
} from "signoxe/actions";

import JSZip from 'jszip';

import { v4 as uuidv4 } from 'uuid';
import { getAuthTokenHeader } from 'signoxe/actions/remote';

class WeatherPage extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            name: "",
            station: "",
            weather: ""
        }
    }

    componentDidMount() {
        const requestOptions = {
            method: 'GET',
            headers: {
                Authorization: getAuthTokenHeader()
            },
        };

        fetch(`${API_ROOT}weather/stations/`, requestOptions).then(response => {
            if (response.ok) {
                return response.json();
            }
        }).then(obj => {
            if (obj) {
                this.props.setWeatherStations(obj);
            }
        });

        this.props.setPageTitle('Adding Airveda Asset'); 
    }


    changeSelectedStation(station) {
        this.setState({ station });
    }

    changeSelectedWeather(weather) {
        this.setState({ weather });
    }

    saveEnabled() {
        return this.state && this.state.name && this.state.station && this.state.weather;
    }

    cancel() {
        this.props.history.push('/assets');
    }

    save() {
        let file;
        const func = this.props.addZipAsset;
        const state = this.state
        const zip = new JSZip();

        const randName = uuidv4();

        zip.file(`rand.txt`, `${randName}`);

        zip.generateAsync({ type: "blob" })
            .then(function (content) {
                file = new File([content], `weather-${randName}.zip`, { type: 'application/zip' })
                func({ ...state, data: JSON.stringify(state), tags: JSON.stringify([state.station]), asset_url: JSON.stringify(state), media_file: file });
            }).then(() => {
                setTimeout(this.props.refresh, 700)
            }) 
    }

    isNewAsset() {
        return this.props.match.params.id === undefined
    };

    render() {
        return <div className="asset-editing-page">
            <p>WEATHER ASSET</p>
            <input type="text" placeholder="Asset name"
                value={this.state.name}
                onChange={event => this.setState({ name: event.target.value })} />
            {
                (this.props.stations.length > 0 ?
                    <select
                        name="station" onChange={event => this.changeSelectedStation(event.target.value)}
                        value={this.state.station}
                    >
                        <option value="">Please choose a weather station</option>
                        {this.props.stations.map(station => <option key={`${station}`} value={station}>{station}</option>)}
                    </select> :
                    <p>Loading stations...</p>
                )
            }

            <select
                name="weatherTemplates" onChange={event => this.changeSelectedWeather(event.target.value)}
                value={this.state.weather}
            >
                <option value="">Please choose a weather template</option>
                {this.props.weatherTemplates.map(weather => <option key={`${weather.id}`} value={weather.id}>{weather.name}</option>)}
            </select>

            <Box direction="row" justifyContent="flex-end" className="actions button-group">
                <Button primary onClick={this.saveEnabled() ? event => this.save() : null}>Save</Button>
            </Box>
        </div>
    }
}

const mapStateToProps = (state, ownProps) => {
    const airVedaStations = state.uiState.airVedaStations;
    return {
        stations: airVedaStations,
        token: state.authState.token,
        weatherTemplates: getWeatherTemplates(state)
        // asset: getAsset(state, parseInt(ownProps.match.params.id, 10)),
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setPageTitle: title => dispatch(setPageTitle(title)),
        setWeatherStations: (stations) => dispatch(setWeatherStations(stations)),

        addZipAsset: data => dispatch(addZipAsset(data)),
        updateAQIVedaAsset: (id, data) => dispatch(updateAQIVedaAsset(id, data)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(WeatherPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/AssetModal/components/Weather.js